import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h20"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "mt20 centered mb10"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: "fw600 fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "mt20 centered mb10 w100 pad30 mb20 centered"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  class: "",
  style: {}
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_14 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_15 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}
const _hoisted_16 = {
  key: 2,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_17 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_18 = { class: "fs14 fw400" }
const _hoisted_19 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_20 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "AlertModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll InputLocationModal",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "pad15",
        style: _normalizeStyle({
                width: `400px`,
                height: `${_ctx.retHeight || 220}px`,
            })
      }, [
        (!_ctx.hideDismissButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                width: "30",
                height: "30",
                class: "posAb pointer",
                style: {"right":"10px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle({
                    height: `${_ctx.contentHeight}px`,
                    overscrollBehavior: `contain`,
                })
        }, [
          (_ctx.Util.isPresent(_ctx.retImageUrl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(_ctx.retImageUrl),
                  width: "40",
                  height: "38",
                  class: ""
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(`title mc ${_ctx.retImageUrl ? `` : `mt30`}`),
            style: {}
          }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.retTitle), 1)
          ], 2),
          _hoisted_7,
          (_ctx.Util.isPresent(_ctx.retImageLargeUrl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(_ctx.retImageLargeUrl),
                  class: "",
                  width: "300"
                }, null, 8, _hoisted_9),
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "fs14 fw600 mt10",
              innerHTML: _ctx.retText
            }, null, 8, _hoisted_12)
          ])
        ], 4)
      ], 4),
      (_ctx.hideCancelButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("section", {
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOK && _ctx.clickOK(...args)))
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.retOkButtonName ? _ctx.retOkButtonName : `決定`), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("section", {
                class: "llgreyBg dgrey fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
              }, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.retCancelButtonName ? _ctx.cancelButtonName : `キャンセル`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("section", {
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickOK && _ctx.clickOK(...args)))
              }, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.retOkButtonName ? _ctx.retOkButtonName : `決定`), 1)
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}